import React, { useState, useEffect } from 'react';
import { Field } from 'redux-form';
import Button from 'react-bootstrap/lib/Button';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { useIntl } from "react-intl";
import { useSelector } from 'react-redux';

import CommonFormComponent from '../CommonField/CommonFormComponent';

import { formatLocale, formatLocaleData } from '../../helpers/formatLocale';
import { isOwnerAIFeatureStatus } from '../../helpers/aiFeatureStatusHelper';
import messages from '../../locale/jsonMessages';

import { AddPlusIcon, RemoveIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
import AskAIButton from '../Common/AskAIButton/AskAIButton';

import cs from '../../components/commonStyle.css';
import s from '../../components/siteadmin/admin-common.css';


const FieldArrayComponent = (props) => {
    const { fields, fieldType, typeId, selectedLanguage, isListing, label, filedName, componentClass, placeholder, activesFields, openAIModal, descListClass, isDouble, fieldConfigs } = props;
    const [isUsedLanguage, setUsedLanguage] = useState();
    const { formatMessage } = useIntl();
    const [isDisabled, setIsDisabled] = useState(true);
    const languages = useSelector(state => state.runtime.isActiveLanguages);
    const [dataField, setDataField] = useState({});
    const aiAccessCarTitleDescription = useSelector(state => state?.siteSettings?.data?.aiAccessCarTitleDescription);
    const isAiFeatureEnabled = useSelector(state => state?.siteSettings?.data?.aiTextGeneration);
    const ownerServicePlanAIFeatureStatus = useSelector(state => state?.account?.data?.ownerServicePlanAIFeatureStatus);
    const aiOwnerAccess = useSelector(state => state?.siteSettings?.data?.aiOwnerAccess);
    let activeLangugeCodes = languages.map((item) => {
        return formatLocaleData(item)
    })
    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsDisabled(false);
        }
    }, []);

    if (activesFields && activesFields.length > 0) {
        useEffect(() => {
            let appendFields = activesFields?.reduce((keys, index) => {
                keys[index] = '';
                return keys;
            }, {});
            appendFields['filedName'] = filedName;
            setDataField(appendFields);
        }, [activesFields])
    }

    useEffect(() => {
        const filteredLanguages = selectedLanguage?.map(item => item.language);
        setUsedLanguage(filteredLanguages)
    }, [selectedLanguage])

    const addField = (fields) => {
        fields.push(dataField);
    }

    !fields.length && addField(fields);


    let isOwnerAITitleAndDescription = isOwnerAIFeatureStatus({
        isOwnerAIEnabled: aiAccessCarTitleDescription,
        isGlobalAIEnabled: isAiFeatureEnabled,
        hasActiveServicePlan: ownerServicePlanAIFeatureStatus,
        servicePlanUsers: aiOwnerAccess
    })


    return (
        <div className={cs.languageBox}>
            {fields && fields?.length > 0 && fields.map((itemName, index) => {
                let fieldLength = fields.length - 1;
                const currentLanguage = fields?.get(index)?.language;

                const availableLanguages = activeLangugeCodes.filter(
                    (locale) => !isUsedLanguage?.includes(locale) || locale === currentLanguage
                );

                const languageValue = [
                    { value: '', label: formatMessage(messages.chooseLanguageLabel) },
                    ...availableLanguages.map(locale => ({
                        value: locale,
                        label: formatLocale(locale)
                    }))
                ];

                return (
                    !isDisabled && <div key={index} >
                        <div className={cx(isDouble ? 'twoColumnGrid' : 'oneColumnGrid')}>
                            <div className={cx(descListClass ? descListClass : 'oneColumnGrid')}>
                                <Field
                                    name={`${itemName}.language`}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.language)}
                                    inputClass='commonSelectField'
                                    labelText={formatMessage(messages.language)}
                                >
                                    {languageValue.map((item) => {
                                        return (<option value={item?.value}>{item?.label}</option>)
                                    })}
                                </Field>
                                {isListing &&
                                    <Field
                                        name={`${itemName}.listTitle`}
                                        type="text"
                                        component={CommonFormComponent}
                                        placeholder={placeholder ? placeholder : label}
                                        componentClass={componentClass && componentClass}
                                        inputClass='commonInputField'
                                        labelText={label}
                                        isRequiredInput
                                    />
                                }
                            </div>

                            {isListing &&
                                <Field
                                    name={`${itemName}.listDescription`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.carDescriptionLabel)}
                                    inputClass='commonTextAreaField'
                                    componentClass="textarea"
                                    labelText={formatMessage(messages.aboutCar)}
                                    isRequiredInput
                                />}


                            {!isListing && !activesFields &&
                                <>
                                    <Field
                                        name={`${itemName}.itemName`}
                                        type="text"
                                        component={CommonFormComponent}
                                        placeholder={formatMessage(messages.addNew)}
                                        inputClass='commonInputField'
                                        labelText={formatMessage(messages.addNew)}
                                        isRequiredInput
                                    />
                                    {typeId && (typeId == 1) &&
                                        <Field
                                            name={`${itemName}.itemDescription`}
                                            component={CommonFormComponent}
                                            type="text"
                                            componentClass={"textarea"}
                                            placeholder={formatMessage(messages.addNewDescription)}
                                            inputClass='commonTextAreaField'
                                            labelText={formatMessage(messages.addNewDescription)}
                                        />
                                    }
                                    {fieldType == 'numberType' &&
                                        <Field
                                            name={`${itemName}.otherItemName`}
                                            type="text"
                                            component={CommonFormComponent}
                                            placeholder={formatMessage(messages.addOtherItem)}
                                            inputClass='commonInputField'
                                            labelText={formatMessage(messages.addOtherItem)}
                                            isRequiredInput
                                        />
                                    }
                                </>}

                            {dataField?.hasOwnProperty('reportType') &&
                                <Field
                                    name={`${itemName}.reportType`}
                                    type='text'
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.tabTitle)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.tabTitle)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('reportContent') &&
                                <Field
                                    name={`${itemName}.reportContent`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.contentLabel)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.contentLabel)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('title') &&
                                <Field
                                    name={`${itemName}.title`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={fieldConfigs?.title?.placeholder ?? (placeholder ?? formatMessage(messages.bannerPlaceholder))}
                                    inputClass='commonInputField'
                                    labelText={fieldConfigs?.title?.label ?? (label ?? formatMessage(messages.titleAdminLabel))}
                                    toolTipText={fieldConfigs?.title?.toolTipText}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('metaTitle') &&
                                <Field
                                    name={`${itemName}.metaTitle`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.metaTitleLabel)}
                                    labelText={formatMessage(messages.metaTitleLabel)}
                                    inputClass='commonInputField'
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('metaDescription') &&
                                <Field
                                    name={`${itemName}.metaDescription`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.metaDescriptionLabel)}
                                    labelText={formatMessage(messages.metaDescriptionLabel)}
                                    inputClass='commonInputField'
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('pageTitle') &&
                                <Field
                                    name={`${itemName}.pageTitle`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={placeholder ? placeholder : formatMessage(messages.bannerPlaceholder)}
                                    inputClass='commonInputField'
                                    labelText={label ? label : formatMessage(messages.titleAdminLabel)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('content') &&
                                <Field
                                    name={`${itemName}.content`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.bannerPlaceholderContent)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.contentLabel)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('heading') &&
                                <Field
                                    name={`${itemName}.heading`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.headingLabel)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.headingLabel)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('buttonLabel') &&
                                <Field
                                    name={`${itemName}.buttonLabel`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.buttonLabel)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.buttonLabel)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('buttonLabel2') &&
                                <Field
                                    name={`${itemName}.buttonLabel2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.buttonLabel) + ' 2'}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.buttonLabel) + ' 2'}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('location') &&
                                <Field
                                    name={`${itemName}.location`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.location)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.location)}
                                    isRequiredInput
                                />
                            }


                            {dataField?.hasOwnProperty('title1') &&
                                <Field
                                    name={`${itemName}.title1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.title1)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.title1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('content1') &&
                                <Field
                                    name={`${itemName}.content1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.content1)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.content1)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('title2') &&
                                <Field
                                    name={`${itemName}.title2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.title2)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.title2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('content2') &&
                                <Field
                                    name={`${itemName}.content2`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.content2)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.content2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('title3') &&
                                <Field
                                    name={`${itemName}.title3`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.title3)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.title3)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('content3') &&
                                <Field
                                    name={`${itemName}.content3`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.content3)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.content3)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('content4') &&
                                <Field
                                    name={`${itemName}.content4`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={`${formatMessage(messages.contentLabel)} #4`}
                                    inputClass='commonTextAreaField'
                                    labelText={`${formatMessage(messages.contentLabel)} #4`}
                                />
                            }
                            {dataField?.hasOwnProperty('content5') &&
                                <Field
                                    name={`${itemName}.content5`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={`${formatMessage(messages.contentLabel)} #5`}
                                    inputClass='commonTextAreaField'
                                    labelText={`${formatMessage(messages.contentLabel)} #5`}
                                />
                            }

                            {dataField?.hasOwnProperty('hostBannerTitle1') &&
                                <Field
                                    name={`${itemName}.hostBannerTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.hostBannerTitle)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.hostBannerTitle)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('hostBannerContent1') &&
                                <Field
                                    name={`${itemName}.hostBannerContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.hostBannerContent)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.hostBannerContent)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('hostBannerContent2') &&
                                <Field
                                    name={`${itemName}.hostBannerContent2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.contentLabel)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.contentLabel)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('earnBlockTitle1') &&
                                <Field
                                    name={`${itemName}.earnBlockTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.earnBlockTitle)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.earnBlockTitle)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('earnBlockContent1') &&
                                <Field
                                    name={`${itemName}.earnBlockContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.earnBlockContent)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.earnBlockContent)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('whyBlockTitle1') &&
                                <Field
                                    name={`${itemName}.whyBlockTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.whyBlockTitleLabel1)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.whyBlockTitleLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('whyBlockContent1') &&
                                <Field
                                    name={`${itemName}.whyBlockContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.whyBlockContentLabel1)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.whyBlockContentLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('whyBlockTitle2') &&
                                <Field
                                    name={`${itemName}.whyBlockTitle2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.whyBlockTitleLabel2)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.whyBlockTitleLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('whyBlockContent2') &&
                                <Field
                                    name={`${itemName}.whyBlockContent2`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.whyBlockContentLabel2)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.whyBlockContentLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('easyHostTitle1') &&
                                <Field
                                    name={`${itemName}.easyHostTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.easyHostTitle1)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.easyHostTitle1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('easyHostContent1') &&
                                <Field
                                    name={`${itemName}.easyHostContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleLabel1)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.workTitleLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('easyHostContent2') &&
                                <Field
                                    name={`${itemName}.easyHostContent2`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleContentLabel1)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.workTitleContentLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('workTitle1') &&
                                <Field
                                    name={`${itemName}.workTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleLabel2)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.workTitleLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('workContent1') &&
                                <Field
                                    name={`${itemName}.workContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleContentLabel2)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.workTitleContentLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('workTitle2') &&
                                <Field
                                    name={`${itemName}.workTitle2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleLabel3)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.workTitleLabel3)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('workContent2') &&
                                <Field
                                    name={`${itemName}.workContent2`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleContentLabel3)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.workTitleContentLabel3)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('workTitleHeading') &&
                                <Field
                                    name={`${itemName}.workTitleHeading`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.workTitleHeading)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.workTitleHeading)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceTitle1') &&
                                <Field
                                    name={`${itemName}.peaceTitle1`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceTitleLabel1)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.peaceTitleLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceContent1') &&
                                <Field
                                    name={`${itemName}.peaceContent1`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceContentLabel1)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.peaceContentLabel1)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceTitle2') &&
                                <Field
                                    name={`${itemName}.peaceTitle2`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceTitleLabel2)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.peaceTitleLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceContent2') &&
                                <Field
                                    name={`${itemName}.peaceContent2`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceContentLabel2)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.peaceContentLabel2)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceTitleHeading') &&
                                <Field
                                    name={`${itemName}.peaceTitleHeading`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceTitleHeading)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.peaceTitleHeading)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceTitle3') &&
                                <Field
                                    name={`${itemName}.peaceTitle3`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.tabTitle)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.tabTitle)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('peaceContent3') &&
                                <Field
                                    name={`${itemName}.peaceContent3`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.peaceContentLabel3)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.peaceContentLabel3)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('userName') &&
                                <Field
                                    name={`${itemName}.userName`}
                                    type="text"
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.name)}
                                    inputClass='commonInputField'
                                    labelText={formatMessage(messages.name)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('reviewContent') &&
                                <Field
                                    name={`${itemName}.reviewContent`}
                                    componentClass={'textarea'}
                                    component={CommonFormComponent}
                                    placeholder={formatMessage(messages.reviewContentLabel)}
                                    inputClass='commonTextAreaField'
                                    labelText={formatMessage(messages.reviewContentLabel)}
                                    isRequiredInput
                                />
                            }
                            {dataField?.hasOwnProperty('planName') &&
                                <Field
                                    name={`${itemName}.planName`}
                                    type="text"
                                    inputClass='commonInputField'
                                    component={CommonFormComponent}
                                    labelText={formatMessage(messages.planNameLabel)}
                                    placeholder={formatMessage(messages.planNameLabel)}
                                    toolTipText={formatMessage(messages.planNameToolTip)}
                                    isRequiredInput
                                />
                            }

                            {dataField?.hasOwnProperty('description') &&
                                <Field
                                    name={`${itemName}.description`}
                                    component={CommonFormComponent}
                                    componentClass="textarea"
                                    inputClass='commonTextAreaField'
                                    labelText={fieldConfigs?.description?.label ?? formatMessage(messages.descriptionAdminLabel)}
                                    placeholder={fieldConfigs?.description?.placeholder ?? formatMessage(messages.descriptionAdminLabel)}
                                    toolTipText={fieldConfigs?.description?.toolTipText ?? formatMessage(messages.planDescriptionToolTip)}
                                    isRequiredInput
                                />
                            }

                        </div>
                        <div className={cx(cs.displayFlex, cs.gap16, cs.justifyContentSpaceBetween, cs.flexWrap, cs.spaceTop2, { [cs.languageBtnContainerOne]: index != 0 })}>
                            {isListing &&
                                <AskAIButton
                                    btnText={formatMessage(messages.generateWithAILabel)}
                                    onClick={openAIModal}
                                    currentIndex={index}
                                    isButtonVisible={isOwnerAITitleAndDescription}
                                />}
                            <div className={cx(cs.displayFlex, cs.gap16, cs.flexWrap, cs.justifyContentFlexEnd, cs.flexGrow)}>
                                {fields?.length > 1 &&
                                    <Button onClick={() => fields.remove(index)} className={cx(cs.linkBtnPrimaryStyle, cs.displayFlex, cs.gap4, cs.alignCenter, s.addLanguageText)}>
                                        <RemoveIcon />
                                        <span>{formatMessage(messages.deleteLanguage)}</span>
                                    </Button>
                                }
                                {(fields.length <= languages?.length - 1) && fieldLength == index &&
                                    <Button onClick={() => fields.length <= languages?.length - 1 && fields.push({})} className={cx(cs.linkBtnPrimaryStyle, cs.displayFlex, cs.gap4, cs.alignCenter, s.addLanguageText)}>
                                        <AddPlusIcon />
                                        <span>{formatMessage(messages.addLanguage)}</span>
                                    </Button>
                                }
                            </div>
                        </div>
                    </div>
                )
            })}
        </div >
    )
}

export default (withStyles(s, cs)(FieldArrayComponent));
